// extracted by mini-css-extract-plugin
export default {"alert":"src-utils-alert-alert__alert"};